import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homeeight-about',
  templateUrl: './homeeight-about.component.html',
  styleUrls: ['./homeeight-about.component.scss']
})
export class HomeeightAboutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
